import { CommonService } from '@/services/common.service'

export default {
}
